import React, { useState } from 'react';
import { X } from 'lucide-react';

export const MonsterWidget = () => {
  const [isOpen, setIsOpen] = useState(false);

  const fees = [
    { app: 'DoorDash', fee: '15-30%', extra: '+ marketing fees, delivery fees' },
    { app: 'Uber Eats', fee: '15-30%', extra: '+ activation fee, tablet rental' },
    { app: 'Grubhub', fee: '15-25%', extra: '+ processing fees, promo costs' },
    { app: 'Postmates', fee: '15-30%', extra: '+ service fees passed to customers' },
  ];

  return (
    <>
      {/* Monster button - bottom right */}
      {!isOpen && (
        <button
          data-testid="monster-btn"
          onClick={() => setIsOpen(true)}
          style={{
            position: 'fixed',
            bottom: '10px',
            right: '10px',
            width: '160px',
            height: '220px',
            border: 'none',
            cursor: 'pointer',
            zIndex: 9997,
            padding: 0,
            background: 'radial-gradient(circle at center, rgba(0,0,0,0.6) 30%, transparent 70%)',
            boxShadow: 'none',
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'center',
            overflow: 'visible',
            transition: 'transform 0.2s',
            borderRadius: '50%',
          }}
          onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.08)'}
          onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
        >
          <img src="/monster.png" alt="High Prices Monster" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
        </button>
      )}

      {/* Modal */}
      {isOpen && (
        <div
          data-testid="monster-modal"
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(0,0,0,0.75)',
            backdropFilter: 'blur(4px)',
          }}
          onClick={(e) => { if (e.target === e.currentTarget) setIsOpen(false); }}
        >
          <div style={{
            width: '95%',
            maxWidth: '600px',
            maxHeight: '90vh',
            borderRadius: '16px',
            overflow: 'hidden',
            background: '#fff',
            border: '4px solid #000',
            boxShadow: '8px 8px 0px 0px #000',
            display: 'flex',
            flexDirection: 'column',
          }}>
            {/* Header */}
            <div style={{
              background: '#000',
              padding: '1.5rem 2rem',
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              gap: '1rem',
            }}>
              <img src="/monster.png" alt="Monster" style={{ width: '70px', height: '70px', objectFit: 'contain' }} />
              <div>
                <h2 style={{ fontFamily: "'Bangers', cursive", color: '#FF3B30', fontSize: '1.75rem', letterSpacing: '0.03em' }}>
                  The Hidden Cost of Delivery Apps
                </h2>
                <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.875rem', fontWeight: 500 }}>
                  See what these apps are really charging you
                </p>
              </div>
              <button
                data-testid="monster-close"
                onClick={() => setIsOpen(false)}
                style={{
                  position: 'absolute', top: '12px', right: '12px',
                  background: 'rgba(255,255,255,0.15)', border: 'none', borderRadius: '50%',
                  width: '32px', height: '32px', display: 'flex', alignItems: 'center',
                  justifyContent: 'center', cursor: 'pointer', color: '#fff',
                }}
              >
                <X size={18} />
              </button>
            </div>

            {/* Content */}
            <div style={{ flex: 1, overflowY: 'auto', padding: '1.5rem 2rem' }}>
              {/* Fee cards */}
              {fees.map((f, i) => (
                <div key={i} style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '1rem',
                  marginBottom: '0.75rem',
                  background: '#FEE2E2',
                  border: '3px solid #FF3B30',
                  borderRadius: '8px',
                  boxShadow: '3px 3px 0px 0px #FF3B30',
                }}>
                  <div>
                    <div style={{ fontWeight: 800, textTransform: 'uppercase', fontSize: '0.95rem' }}>{f.app}</div>
                    <div style={{ color: '#666', fontSize: '0.8rem', fontWeight: 500 }}>{f.extra}</div>
                  </div>
                  <div style={{
                    fontFamily: "'Bangers', cursive",
                    fontSize: '1.75rem',
                    color: '#FF3B30',
                    letterSpacing: '0.03em',
                  }}>
                    {f.fee}
                  </div>
                </div>
              ))}

              {/* Comparison callout */}
              <div style={{
                marginTop: '1.25rem',
                padding: '1.25rem',
                background: '#FFD700',
                border: '4px solid #000',
                borderRadius: '8px',
                boxShadow: '4px 4px 0px 0px #000',
                textAlign: 'center',
              }}>
                <div style={{ fontFamily: "'Bangers', cursive", fontSize: '1.25rem', marginBottom: '0.25rem', letterSpacing: '0.03em' }}>
                  With HungrMates
                </div>
                <div style={{ fontFamily: "'Bangers', cursive", fontSize: '2.5rem', color: '#6A0DAD', letterSpacing: '0.03em' }}>
                  0% Commission
                </div>
                <div style={{ fontWeight: 700, fontSize: '0.9rem', color: '#333', marginTop: '0.25rem' }}>
                  Just $297/mo flat. Keep 100% of every order.
                </div>
              </div>

              {/* Bottom stats */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem', marginTop: '1.25rem' }}>
                <div style={{ padding: '1rem', background: '#F3F4F6', border: '3px solid #000', borderRadius: '8px', textAlign: 'center', boxShadow: '3px 3px 0px 0px #000' }}>
                  <div style={{ fontFamily: "'Bangers', cursive", fontSize: '1.75rem', color: '#FF3B30' }}>$1,200+</div>
                  <div style={{ fontWeight: 700, fontSize: '0.8rem', textTransform: 'uppercase' }}>Avg monthly loss to delivery apps</div>
                </div>
                <div style={{ padding: '1rem', background: '#F3F4F6', border: '3px solid #000', borderRadius: '8px', textAlign: 'center', boxShadow: '3px 3px 0px 0px #000' }}>
                  <div style={{ fontFamily: "'Bangers', cursive", fontSize: '1.75rem', color: '#6A0DAD' }}>$14,400+</div>
                  <div style={{ fontWeight: 700, fontSize: '0.8rem', textTransform: 'uppercase' }}>You could save per year</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
